const PointTypesGraphQL = {
    PICKUP: "Pickup",
    DELIVERY: "Delivery",
};

export default PointTypesGraphQL;
